import { useEffect } from "react";

/**
 * Calls the callback every time the tab or window regains focus.
 */
export function useRefocus(
  callback: () => void,
  { immediate = false }: { immediate?: boolean } = {}
) {
  useEffect(() => {
    const handleFocus = () => callback();

    if (immediate) {
      callback();
    }

    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleFocus);
    };
  }, [callback, immediate]);
}
